import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Database } from './database.types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Debug environment variables
console.log('Supabase Configuration:', {
  hasUrl: !!supabaseUrl,
  hasKey: !!supabaseAnonKey
});

if (!supabaseUrl) {
  throw new Error('Missing environment variable: VITE_SUPABASE_URL');
}

if (!supabaseAnonKey) {
  throw new Error('Missing environment variable: VITE_SUPABASE_ANON_KEY');
}

// Ensure URL has https:// prefix
const finalUrl = supabaseUrl.startsWith('http') ? supabaseUrl : `https://${supabaseUrl}`;

try {
  new URL(finalUrl); // Validate URL format
  console.log('Supabase URL validated successfully');
} catch (error) {
  console.error('Invalid Supabase URL:', finalUrl);
  throw error;
}

let supabaseInstance: SupabaseClient<Database> | null = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(finalUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
        storageKey: 'intern-trackr-auth-key',
        flowType: 'pkce',
        debug: false, // Disable debug to reduce overhead
        // Remove custom storage overrides to use default fast storage
      },
      // Add global options for better performance
      global: {
        headers: {
          'X-Client-Info': 'intern-trackr'
        }
      }
    });
    console.log('Supabase client initialized');
  }
  return supabaseInstance;
};

// Export a singleton instance
export const supabase = getSupabase();
